<template>
  <div class="Pie5Charts">
    <div class="echarts" :id="Configuration.id"></div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import { request } from '../../../../common/request';
export default {
  name: 'Pie5Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      console.log(grid);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(source);
      console.log(seriesList);

      let xData = [];
      let yData = [];
      let xyData = [];

      function DealData() {
        seriesList.forEach(s => {
          source.forEach(item => {
            if (s === item.s) {
              console.log(s, item, 'item item 5555555');
              xData.push(item.x);
              yData.push(item.y);
              xyData.push({
                name: item.x,
                value: parseInt(item.y),
              });
            }
          });
        });
      }
      DealData();
      var num1 = 50;
      var num3 = 38;
      // var num4 = 65;
      var num5 = 55;
      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        title: [
          {
            text: '',
            x: '50%',
            y: 30,
            textAlign: 'center',
            textStyle: {
              align: 'center',
              color: '#333',
              fontSize: 30,
              fontWeight: '100',
            },
          },
          {
            left: '49.5%',
            top: '50%',
            textAlign: 'center',
            textStyle: {
              fontSize: '16',
              color: '#535353',
              textAlign: 'center',
              fontWeight: '400',
            },
          },
        ],
        series: [
          {
            type: 'pie',
            radius: ['30%', '37%'],
            center: ['50%', '50%'],
            startAngle: -150,
            data: [
              {
                hoverOffset: 1,
                value: num1,
                name: '',
                itemStyle: {
                  color: '#d0276c',
                },
                label: {
                  normal: {
                    show: true,
                    formatter: '{r|{c}%}',
                    rich: {
                      r: {
                        color: 'rgba(255,255,255,1)',
                        fontWeight: 'bold',
                        fontSize: 18,
                      },
                    },
                    position: 'inside',
                    color: '#FFF',
                    textShadowBlur: 5,
                    textShadowOffsetX: 1,
                    textShadowOffsetY: 2,
                    textShadowColor: 'rgba(0,0,0,0.3)',
                  },
                },
                labelLine: {
                  normal: {
                    smooth: true,
                    lineStyle: {
                      width: 0,
                    },
                  },
                },
                hoverAnimation: false,
              },
              {
                label: {
                  show: false,
                },
                labelLine: {
                  normal: {
                    smooth: true,
                    lineStyle: {
                      width: 0,
                    },
                  },
                },
                value: 100 - num1,
                hoverAnimation: false,
                itemStyle: {
                  color: 'rgba(0, 0, 0, 0)',
                },
              },
            ],
          },

          {
            type: 'pie',
            radius: ['44%', '51%'],
            center: ['50%', '50%'],
            startAngle: -70,
            data: [
              {
                hoverOffset: 1,
                value: num3,
                name: '',
                itemStyle: {
                  color: '#4e2e9b',
                },
                label: {
                  normal: {
                    show: true,
                    formatter: '{r|{c}%}',
                    rich: {
                      r: {
                        color: 'rgba(255,255,255,1)',
                        fontWeight: 'bold',
                        fontSize: 18,
                      },
                    },
                    position: 'inside',
                    color: '#FFF',
                    textShadowBlur: 5,
                    textShadowOffsetX: 1,
                    textShadowOffsetY: 2,
                    textShadowColor: 'rgba(0,0,0,0.3)',
                  },
                },
                labelLine: {
                  normal: {
                    smooth: true,
                    lineStyle: {
                      width: 0,
                    },
                  },
                },
                hoverAnimation: false,
              },
              {
                label: {
                  show: false,
                },
                labelLine: {
                  normal: {
                    smooth: true,
                    lineStyle: {
                      width: 0,
                    },
                  },
                },
                value: 100 - num3,
                hoverAnimation: false,
                itemStyle: {
                  color: 'rgba(0, 0, 0, 0)',
                },
              },
            ],
          },

          {
            type: 'pie',
            radius: ['58%', '65%'],
            center: ['50%', '50%'],
            startAngle: 50,
            data: [
              {
                hoverOffset: 1,
                value: num5,
                name: '',
                itemStyle: {
                  color: '#61c8f1',
                },
                label: {
                  normal: {
                    show: true,
                    formatter: '{r|{c}%}',
                    rich: {
                      r: {
                        color: 'rgba(255,255,255,1)',
                        fontWeight: 'bold',
                        fontSize: 18,
                      },
                    },
                    position: 'inside',
                    color: '#FFF',
                    textShadowBlur: 5,
                    textShadowOffsetX: 1,
                    textShadowOffsetY: 2,
                    textShadowColor: 'rgba(0,0,0,0.3)',
                  },
                },
                labelLine: {
                  normal: {
                    smooth: true,
                    lineStyle: {
                      width: 0,
                    },
                  },
                },
                hoverAnimation: false,
              },
              {
                label: {
                  show: false,
                },
                labelLine: {
                  normal: {
                    smooth: true,
                    lineStyle: {
                      width: 0,
                    },
                  },
                },
                // value: 100 - num4,
                value: yData,
                hoverAnimation: false,
                itemStyle: {
                  color: 'rgba(0, 0, 0, 0)',
                },
              },
            ],
          },

          {
            type: 'pie',
            radius: ['30%', '37%'],
            center: ['50%', '50%'],
            startAngle: -150,
            name: '',
            silent: true,
            z: 1,
            hoverAnimation: false, //鼠标移入变大
            label: {
              show: false,
            },
            itemStyle: {
              borderCap: 'round',
              borderJoin: 'round',
            },
            data: [
              {
                value: 7.5,
                itemStyle: {
                  color: '#d0276c10',
                },
              },
            ],
          },

          {
            type: 'pie',
            radius: ['44%', '51%'],
            center: ['50%', '50%'],
            startAngle: -70,
            name: '',
            silent: true,
            z: 1,
            hoverAnimation: false, //鼠标移入变大
            label: {
              show: false,
            },
            itemStyle: {
              borderCap: 'round',
              borderJoin: 'round',
            },
            data: [
              {
                value: 7.5,
                itemStyle: {
                  color: '#4e2e9b10',
                },
              },
            ],
          },

          {
            type: 'pie',
            radius: ['58%', '65%'],
            center: ['50%', '50%'],
            startAngle: 50,
            name: '',
            silent: true,
            z: 1,
            hoverAnimation: false, //鼠标移入变大
            label: {
              show: false,
            },
            itemStyle: {
              borderCap: 'round',
              borderJoin: 'round',
            },
            data: [
              {
                value: 7.5,
                itemStyle: {
                  color: '#61c8f110',
                },
              },
            ],
          },
        ],
      };
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.staticIntervalTaskID = setInterval(() => {
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        // this.axios({
        //   method: 'get',
        //   url: ChartsData.apiData.apiUrl,
        // })
        let param = {
          method: 'get',
          url: ChartsData.apiData.apiUrl,
        };

        request(param)
          .then(res => {
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '多轴圆角环形图',
    componentName: 'Pie5Charts',
    componentOverViewImg: './img/charts/PieCharts/Pie5Charts.png',
    id: '',
    style: {
      width: 300,
      height: 150,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['人数'],
            source: [
              {
                s: '人数',
                y: '122',
                x: '2021-06-02 12:10:51',
                i: 1,
              },
              {
                s: '人数',
                y: '67',
                x: '2021-06-02 11:10:51',
                i: 2,
              },
              {
                s: '人数',
                y: '55',
                x: '2021-06-02 09:10:51',
                i: 3,
              },
              {
                s: '人数',
                y: '34',
                x: '2021-06-02 08:10:51',
                i: 4,
              },
              {
                s: '人数',
                y: '12',
                x: '2021-06-02 07:10:51',
                i: 5,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '5%',
          top: '5%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Pie5Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
}
</style>
